import * as Types from '../../gql.generated';

import { ChangeTrackingFragmentFragment } from '../ProvingDetailsView/hooks/changeFragment.generated';
import gql from 'graphql-tag';
import { ChangeTrackingFragmentFragmentDoc } from '../ProvingDetailsView/hooks/changeFragment.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadHomeQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadHomeQuery = (
  { __typename?: 'Query' }
  & { provings: Array<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_deleted' | 'id' | '_id' | 'status' | 'title' | 'description' | 'dateTo' | 'dateFrom' | 'hasIncompleteBookings' | 'created' | 'hrgIsEditing'>
    & { _changes: Types.Maybe<{ __typename?: 'ProvingChangeTracking' }
      & ChangeTrackingFragmentFragment
    >, maintenanceHead: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, createdBy: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    ), provingGround: Types.Maybe<(
      { __typename?: 'ProvingGround' }
      & Pick<Types.ProvingGround, '_id' | 'title' | 'countryCode'>
      & { clearing: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
      )>>, authorizedEditors: Types.Maybe<Array<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
      )>> }
    )>, editor: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, responsible: Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>, resourceManager: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>>, hrgEditor: Types.Maybe<Array<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'lastName' | 'firstName' | 'name' | 'department' | 'email' | 'upn'>
    )>> }
  )>, principal: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, '_id' | 'type' | 'upn' | 'name' | 'email' | 'roles'>
  )>, multinews: Array<(
    { __typename?: 'News' }
    & Pick<Types.News, '_id' | 'title' | 'description' | 'body' | 'modified' | 'inactive' | '_deleted'>
  )> }
);

export const ReadHomeDocument = gql`
    query ReadHome($search: String) {
  provings(filter: {OR: [{title: {REGEX: $search, OPTIONS: "i"}}, {id: {REGEX: $search, OPTIONS: "i"}}, {department: {REGEX: $search, OPTIONS: "i"}}], status: {NIN: [8, 9, 10]}}) {
    _changes {
      ...ChangeTrackingFragment
    }
    _deleted
    id
    _id
    status
    title
    description
    dateTo
    dateFrom
    hasIncompleteBookings
    maintenanceHead {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    created
    createdBy {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    provingGround {
      _id
      title
      countryCode
      clearing {
        _id
        lastName
        firstName
        name
        department
        email
        upn
      }
      authorizedEditors {
        _id
        lastName
        firstName
        name
        department
        email
        upn
      }
    }
    editor {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    responsible {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    resourceManager {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    hrgEditor {
      _id
      lastName
      firstName
      name
      department
      email
      upn
    }
    hrgIsEditing
  }
  principal {
    _id
    type
    upn
    name
    email
    roles
  }
  multinews(filter: {_deleted: {NEQ: true}, inactive: {NEQ: true}}, sort: {modified: ASC}) {
    _id
    title
    description
    body
    modified
    inactive
    _deleted
  }
}
    ${ChangeTrackingFragmentFragmentDoc}`;

    export function useReadHomeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadHomeQuery, ReadHomeQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadHomeQuery, ReadHomeQueryVariables>(ReadHomeDocument, baseOptions);
    };
      export function useReadHomeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadHomeQuery, ReadHomeQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadHomeQuery, ReadHomeQueryVariables>(ReadHomeDocument, baseOptions);
      };
      
export type ReadHomeQueryHookResult = ReturnType<typeof useReadHomeQuery>;
export type ReadHomeQueryResult = ApolloReactCommon.QueryResult<ReadHomeQuery, ReadHomeQueryVariables>;